import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { PDF, View } from '../../../../components/Icon';
import { List, Row, Cell as TCell } from '../../../../components/List';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { formatLicensePlate } from '../../../../utils/string';
import { selectWorks } from '../../../Api/selectors';
import { kanbanMock, performAction, refreshBoards } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { BaseCellComp } from './../BaseCellComp';
import { Cell } from '../Cell';
import { CellButton, CellButtons } from './../CellButton';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { Well } from '../../../../components/Well';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { SetBVIDone } from './SetBVIDone';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { selectVehicle } from '../../../Vehicles/selectors';
import styles from './BVI.module.css';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

const Container = styled.div``;

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class ApproveBVICellComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  renderApprove() {
    if (!this.state.approve || !this.props.vehicle) return null;

    let document = this.props.vehicle.documents.find(d => d.description == 'bvi');

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('kanbanboards.cell.approvebvi.modal.title')}>
        <div className="text-center mb-2">
          {document ? (
            <ButtonComponent style={'ButtonSoftPrimary'} onClick={() => window.open(`/storage/${document.fileName}`)}>
              <PDF /> Bekijk document
            </ButtonComponent>
          ) : null}
        </div>

        <List>
          <Row>
            <TCell>Kenteken</TCell>
            <TCell>{formatLicensePlate(this.vehicle.regplate)} </TCell>
          </Row>
        </List>
        <Well>
          <label className="form-label">Plaatafgifte codes:</label>

          <input
            className="form-control"
            name="regplate_code"
            value={this.state.regplate_code}
            onChange={this.onInputChange.bind(this)}
          />
        </Well>

        <div className="d-flex gap-2 flex-wrap">
          <SetBVIDone className={styles.confirmButton} vehicle={this.vehicle} onComplete={this.reset.bind(this)} />
          <ButtonComponent
            style={'ButtonSoftEdit'}
            onClick={() => {
              this.reset();
              this.confirm();
            }}
          >
            {this.lbl('confirm')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </div>
            )}
          </CellButtons>
        </Container>
        <WithVehicle vehicle_id={this.vehicle.id} loader>
          {this.renderApprove()}
        </WithVehicle>
      </Cell>
    );
  }
}

ApproveBVICellComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId + '_' + ownProps.cell.vehicle.id]),

    vehicle: selectVehicle(ownProps.cell.vehicle.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ApproveBVICell = compose(withConnect, withRouter)(ApproveBVICellComp);
